<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10" cy="10" r="7" :stroke="color" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.5 7C9.5 6.72386 9.72386 6.5 10 6.5C10.2761 6.5 10.5 6.72386 10.5 7V11C10.5 11.2761 10.2761 11.5 10 11.5C9.72386 11.5 9.5 11.2761 9.5 11V7Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.5 13C9.5 12.7239 9.72386 12.5 10 12.5C10.2761 12.5 10.5 12.7239 10.5 13C10.5 13.2761 10.2761 13.5 10 13.5C9.72386 13.5 9.5 13.2761 9.5 13Z"
      :fill="color"
    />
  </svg>
</template>

<script>
  export default {
    props: {
      width: {
        type: [Number, String],
        default: 20,
      },
      height: {
        type: [Number, String],
        default: 20,
      },
      color: {
        type: String,
        default: 'currentColor',
      },
    },

    computed: {
      viewBox() {
        return `0 0 ${this.width} ${this.height}`
      },
    },
  }
</script>
